import React, { useState } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import dayjs from "dayjs";

import { customStyles } from "../../../Bookclosure/Components/AddTaskModal";
import InputGroup from "./../../elements/InputGroup";
import { ReactComponent as CloseGreyIcon } from "../../assets/icons/close_grey.svg";
import { ReactComponent as CalenderIcon } from "../../assets/icons/calender.svg";
import CustomDropdownIndicator from "../../elements/CustomDropdownIndicator";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";

import commoncss from "../../css/common.module.css";

const animatedComponents = makeAnimated();

const FilterRow = ({ onChange, onRemove, filterAttr = [], assignOptions, approveOptions }) => {
  const filterOptions = filterAttr.map((f) => ({
    label: f.name,
    value: f.key,
  }));

  const [selectedField, setSelectedField] = useState(null);
  const [selectedType, setSelectedType] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [selectedInputType, setSelectedInputType] = useState(null);

  const handleFieldChange = (selectedOption) => {
    const filterDef = filterAttr.find((f) => f.key === selectedOption.value);
    setSelectedField(filterDef);
    setSelectedType(null);
    setInputValue("");
    setSelectedInputType(filterDef.type);
    if (filterDef) {
      onChange({
        key: filterDef.key,
        type: filterDef.type,
        fieldType: filterDef.fieldType,
        filterType: null,
        value: "",
      });
    }
  };

  const handleTypeChange = (selectedOption) => {
    setSelectedType(selectedOption.value);
    if (selectedField) {
      onChange((prev) => ({
        ...prev,
        filterType: selectedOption.value,
      }));
    }
  };

  const handleInputChange = (value) => {
      setInputValue(value);
    if (selectedField && selectedType) {
      onChange((prev) => ({
        ...prev,
        value: value
      }));
    }
  };

  const handleDropdownChange = (option) => {
    setInputValue(option.value);
    
    if (selectedField && selectedType) {
      onChange((prev) => ({
        ...prev,
        value: option.value
      }));
    }
  };

  const filterTypeOptions = selectedField
    ? selectedField.filterTypes.map((type) => ({
        label: type,
        value: type,
      }))
    : [];

  return (
    <>
      <Select
        placeholder="Select Field"
        value={
          selectedField
            ? { label: selectedField.name, value: selectedField.key }
            : null
        }
        onChange={handleFieldChange}
        options={filterOptions}
        className="w-100 mt-0"
        classNamePrefix="select"
              components={{
                ...animatedComponents,
                IndicatorSeparator: () => null,
                DropdownIndicator: CustomDropdownIndicator,
              }}
        styles={{
          ...customStyles,
          menuPortal: base => ({ ...base, zIndex: 9999 })
        }}
        menuPortalTarget={document.body} 
        // menuPosition="static"
        // menuPlacement="bottom"
      />

      <Select
        placeholder="Select Type"
        value={
          selectedType ? { label: selectedType, value: selectedType } : null
        }
        onChange={handleTypeChange}
        options={filterTypeOptions}
        isDisabled={!selectedField}
        className="w-100 mt-0"
        classNamePrefix="select"
              components={{
                ...animatedComponents,
                IndicatorSeparator: () => null,
                DropdownIndicator: CustomDropdownIndicator,
              }}
        styles={{
          ...customStyles,
          menuPortal: base => ({ ...base, zIndex: 9999 })
        }}
        menuPortalTarget={document.body} 
        // menuPosition="static"
        // menuPlacement="bottom"
      />

      {/* {(!selectedInputType || selectedInputType !== "date") && ( */}
      {selectedInputType === "date" ? (
        <InputGroup 
          key="filter-date-input"
          inputs={[
            <>
              <LocalizationProvider dateAdapter={AdapterDayjs} key="filter-date-picker">
                <DemoContainer components={["DatePicker", "MobileDatePicker"]}>
                  <MobileDatePicker
                    className={`${commoncss.datePickerContainer} ${commoncss.clickable}`}
                    disabled={!selectedType}
                    value={inputValue ? dayjs(inputValue, "DD-MM-YYYY") : null}
                    onChange={(newValue) => {
                      handleInputChange(newValue ? dayjs(newValue).format("DD-MM-YYYY") : "");
                    }}
                    format="DD-MMM-YYYY"
                    slotProps={{
                      textField: {
                        InputProps: {
                          disableUnderline: true,
                        },
                        inputProps: {
                          placeholder: "DD-MM-YYYY",
                        },
                        sx: {
                          '& fieldset': {
                            border: 'none',
                          },
                        },
                      },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              <span className="icon">
                <CalenderIcon
                  className="vaMiddle"
                  width={20}
                  height={20}
                />
              </span>
            </>
          ]}
        />
          
      ): selectedInputType === "people" ? (
        <Select
          value={
            (selectedField?.key === "approverID" ? approveOptions : assignOptions).find(
              (opt) => opt.value === inputValue
            ) || null
          }
          isDisabled={!selectedType}
          options={selectedField?.key === "approverID" ? approveOptions : assignOptions}
          onChange={(option) => handleDropdownChange(option)}
          className="w-100 mt-0"
          classNamePrefix="select"
            components={{
              ...animatedComponents,
              IndicatorSeparator: () => null,
              DropdownIndicator: CustomDropdownIndicator,
            }}
          styles={customStyles}
          menuPosition="static"
          menuPlacement="bottom"
        />
      ): (
        <InputGroup 
          inputs={[
            <input
              key="filter-input"
              type="text"
              disabled={!selectedType}
              value={inputValue}
              onChange={(e) => handleInputChange(e.target.value)}
            />
          ]}
        />
      // <input
      //   type="text"
      //   disabled={!selectedType}
      //   value={inputValue}
      //   onChange={(e) => handleInputChange(e.target.value)}
      //   className="w-100"
      // />
    )}
      
      {/* <InputGroup
        inputs={[
          <input
            key="filter-input"
            type={selectedInputType === "date" ? "date" : "text"}
            disabled={!selectedType}
            // value={inputValue}
            onChange={(e)=>(handleInputChange(selectedInputType === "date" ?dayjs(e.target.value).format("DD-MM-YYYY"):e.target.value))}
          />,
        ]}
      /> */}
      {/* // )} */}
      {/* {selectedInputType === "date" && (
        <InputGroup
          inputs={[
            <input
              key="filter-input"
              type="date"
              disabled={!selectedType}
              value={inputValue}
              onChange={handleInputChange}
            />,
          ]}
        />
      )} */}
      <button
        onClick={onRemove}
        style={{
          background: "transparent",
          border: "none",
          fontSize: "1.2rem",
          cursor: "pointer",
          alignSelf: "baseline",
        }}
        title="Remove filter"
      >
        <CloseGreyIcon />
      </button>
    </>
  );
};

export default FilterRow;
